import { ILogMessageParams } from './i_log_message_params';

export class LogEntry {
  /*
   * INSTANCE FIELDS
   */
  message!: string;
  params!: ILogMessageParams;

  entry_message_pattern: string = '';

  column_log_time: string = '';
  column_log_time_style: string = '';

  column_diff_time: string = '';
  column_diff_time_style: string = '';

  column_bytes: string = '';
  column_bytes_style: string = '';

  column_log_entry_id: string = '';
  column_log_entry_id_style: string = '';

  column_message: string = '';
  column_message_style: string = '';

  constructor() {}

  get_log_line() {
    return `${this.column_log_time} ${this.column_diff_time} ${this.column_bytes} ${this.column_log_entry_id} ${this.column_message}`;
  }

  get_log_line_pattern() {
    return `%c${this.column_log_time} %c${this.column_diff_time} %c${this.column_bytes} %c${this.column_log_entry_id} %c${this.column_message}`;
  }

  get_styles_for_pattern() {
    let out = [];

    out.push(this.column_log_time_style);
    out.push(this.column_diff_time_style);
    out.push(this.column_bytes_style);
    out.push(this.column_log_entry_id_style);
    out.push(this.column_message_style);

    return out;
  }
}
